import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminAreaConfigPage.setFetching(isFetching)

const fetchAreas = () => {
  return request.get(constants.marketplace.environmentArea)
    .then(({ data }) => data)
    .then((data) => {
      reducers.marketplace.adminAreaConfigPage.setAreas(data)
      return data
    })
    .catch((error) => console.log(error))
}

const fetchAreaTools = (areaId) => {
  return request.get(constants.marketplace.environmentAreaTools + `/${areaId}`)
    .then(({ data }) => data)
    .then((tools) => reducers.marketplace.adminAreaConfigPage.setAreaTools({ areaId, tools }))
    .catch((error) => console.log(error))
}

const fetchToolTypes = () => {
  return request.get(constants.marketplace.environmentToolType)
    .then(({ data }) => data)
    .then((toolTypes) => {
      reducers.marketplace.adminAreaConfigPage.setToolTypes(toolTypes)

      return toolTypes
    })
    .catch((error) => console.log(error))
}

const fetchToolsByType = (type) => {
  return request.get(constants.marketplace.environmentToolType + `/${type}`)
    .then(({ data }) => data)
    .then((tools) => reducers.marketplace.adminAreaConfigPage.setToolsByType({ type, tools }))
    .catch((error) => console.log(error))
}

const setToolsByType = ({ type, tools }) => {
  return request.post(constants.marketplace.environmentToolType + `/${type}`, tools)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const addArea = (area) => {
  return request.post(constants.marketplace.environmentCreateArea, area)
    .then(({ data }) => data)
    .then((data) => data.created)
    .catch((error) => console.log(error))
}

const editAreas = (areas) => {
  console.log({ areas })
  return request.post(constants.marketplace.environmentArea, areas)
    .then(({ data }) => data)
    .then((data) => data)
    .catch((error) => console.log(error))
}

const setAreaTools = ({ areaId, tools }) => {
  return request.post(constants.marketplace.environmentAreaTools + `/${areaId}`, tools)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const setImage = ({ areaId, image }) => {
  return request.put(constants.marketplace.environmentAreaImage, {
    id: areaId,
    img: image,
  })
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}


export default {
  setFetching,

  fetchAreas,
  addArea,
  editAreas,
  fetchAreaTools,
  fetchToolTypes,
  fetchToolsByType,
  setToolsByType,
  setAreaTools,
  setImage,
}
